<template>
  <el-header class="header-navdep">
    <div class="logo">
      <img src="@/assets/img/headerNav/headerlogb.png" alt="" @click="goto" />
    </div>
    <img class="cd" @click="show" src="@/assets/img/headerNav/sh.svg" alt="" />
    <el-menu
      :default-active="activeIndex"
      class="header-menu"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="1">{{
        $t("components[0].headerNavDep[0]")
      }}</el-menu-item>
      <el-menu-item index="2">{{
        $t("components[0].headerNavDep[1]")
      }}</el-menu-item>
      <el-menu-item index="3">{{
        $t("components[0].headerNavDep[2]")
      }}</el-menu-item>
      <el-menu-item index="4">{{
        $t("components[0].headerNavDep[3]")
      }}</el-menu-item>
      <el-menu-item index="5">{{
        $t("components[0].headerNavDep[4]")
      }}</el-menu-item>
      <el-menu-item index="6">{{
        $t("components[0].headerNavDep[5]")
      }}</el-menu-item>
      <el-submenu index="7" class="header-nav-item" v-if="yy">
        <template #title>
          <img src="@/assets/img/shopdetail/dq.png" alt="" class="img-flag"
        /></template>
        <el-menu-item class="el-menu-detil" index="7-1">EN</el-menu-item>
        <el-menu-item class="el-menu-detil" index="7-2"
          >اللغة العربية</el-menu-item
        >
      </el-submenu>
    </el-menu>
    <div class="input-box" v-if="!yy">
      <el-input
        v-model="input"
        suffix-icon="el-icon-search"
        @input="selectshop"
        class="el-300type"
      ></el-input>
      <div class="show" @click="clickss"></div>
      <div class="show-shop-list" v-show="showlist.length > 0">
        <div
          v-for="(item, index) in showlist"
          :key="index"
          @click="gotoshop(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="img-box" v-if="yy" @click="clickss">
      <img src="@/assets/img/headerNav/ss.png" alt="" />
    </div>
    <sidebar v-show="sidebarShow" @close="close" />
  </el-header>
</template>

<script>
import Sidebar from "./sidebar.vue";
export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      activeIndex: "", // 默认选中的菜单项
      router: {
        1: "freezeDried",
        2: "vacuumFried",
        3: "semiDried",
        4: "toastedDried",
        5: "airdired",
        6: "nut",
      },
      sidebarShow: false,
      input: "",
      shopList: [],
      showlist: [],
      active: false,
    };
  },
  props: {
    yy: {
      type: Boolean,
      default: false, // 默认标题
    },
  },
  watch: {
    $route(to, from) {
      this.active = false;
      this.input = "";
      this.showlist = [];
      let path = to.path;
      path = path.substring(1);
      Object.keys(this.router).forEach((key) => {
        if (this.router[key] == path) {
          this.activeIndex = key;
          this.active = true;
        }
        if (!this.active) {
          this.activeIndex = "";
        }
      });
      // 这里可以根据路由变化决定是否隐藏导航栏
      // this.activeIndex = to.path === "/about"; // 示例: 当访问 '/about' 时隐藏导航
    },
  },
  created() {
    this.shopList = [
      ...shop.vacuumFried,
      ...shop.freezeDried,
      ...shop.airdired,
      ...shop.semiDried,
      ...shop.nut,
      ...shop.toastedDried,
    ];
    console.log(this.shopList);
  },
  methods: {
    clickss() {
      this.yy = !this.yy;
    },
    handleSelect(index) {
      if (index == "7-1") {
        this.$emit("changeLanguage", "en");
        return;
      } else if (index == "7-2") {
        this.$emit("changeLanguage", "alb");
        return;
      }
      if (this.activeIndex == index) return;
      this.activeIndex = index; // 更新选中的菜单项
      // 可以在这里进行路由导航等操作
      console.log(`选择了菜单: ${index}`);
      this.$router.push({
        name: this.router[index],
      });
    },
    show() {
      this.sidebarShow = true;
    },
    goto() {
      this.$router.push({
        name: "home",
      });
    },
    close() {
      this.sidebarShow = false;
    },
    selectshop() {
      if (this.input.length > 4) {
        this.showlist = this.shopList.filter((item) =>
          item.name.includes(this.input)
        );
        console.log(this.showlist);
      } else {
        this.showlist = [];
      }
    },
    gotoshop(item) {
      this.$router.push({
        name: "excessive",
        params: {
          detail: item.detail,
          name: item.name,
          dtype: item.dtype,
          showdtype: item.showdtype,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.img-flag {
  width: 24px;
}
.header-menu {
  // line-height: 80px; /* 调整菜单的高度 */
  margin: 0 auto;
  background: #002552;
  position: relative;
}
.header-navdep {
  height: 80px !important;
  padding-top: 10px !important;
}
.el-header {
  display: flex;
  padding: 0;
  width: 100%;
  background: #002552;
  // height: 80px !important;
}
.logo {
  cursor: pointer;
  width: 82px;
  margin-left: 12.4%;
  img {
    margin-top: 8px;
    width: 100%;
  }
}
.cd {
  width: 40px;
  height: 40px;
  margin-top: 10px;
  margin-left: 110px;
}
::v-deep.el-submenu .el-submenu__title {
  font-family: "Roboto-Bold";
  font-size: 14px;
  color: #fff !important;
}
::v-deep.el-submenu.is-active .el-submenu__title {
  color: #a7986d !important;
}
.el-menu-item {
  font-family: "Roboto-Bold";
  font-size: 14px;
  color: #fff !important;
}
::v-deep .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: #002552 !important;
}
.el-menu-item.is-active {
  color: #a7986d !important;
}
.input-box {
  margin-top: 10px;
  margin-right: 12.4%;
  width: 216px;
  height: 40px;
  position: relative;
  .show {
    position: absolute;
    width: 40px;
    height: 40px;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  @media screen and (max-width: 510px) {
    .el-300type {
      transform: translateY(-100px);
      // position: relative;
      // top: -60px;
    }
  }
  @media screen and (max-width: 490px) {
    .el-300type {
      transform: translateY(-26px);
      // position: relative;
      // top: -60px;
    }
  }

  .show-shop-list {
    position: absolute;
    top: 40px;
    width: 216px;
    background: #fff;
    font-size: 16px;
    border: 1px solid #002552;
    color: #002552;
    z-index: 99999;

    text-align: left;
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 6px 12px;
      cursor: pointer;
    }
  }
}
.img-box {
  margin-top: 10px;
  margin-right: 12.4%;
  width: 40px;
  height: 40px;
  background: #a7986d !important;
  border-radius: 5px;
  margin-left: 176px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  img {
    width: 15.7px;
    height:  15.7px;
  }
}
::v-deep .el-input__suffix {
  right: 0 !important;
  .el-input__icon {
    width: 40px;
    background: #a7986d;
  }
}
.el-menu--horizontal > .el-menu-item {
  height: 70px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 4px solid #a7986d;
}
.header-nav-item {
  position: absolute;
  right: -300px;
}
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: #002552 !important;
}
</style>
